/**
 * Application Configuration
 * Centralized configuration for different environments
 * Supports both hardcoded config and environment variables
 */

const ENV = process.env.NODE_ENV || "production";

// API Configuration
const API_CONFIG = {
  development: {
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "10000", 10),
  },
  production: {
    baseURL:
      process.env.REACT_APP_API_BASE_URL || "https://innobig.com/api/api",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "10000", 10),
  },
  staging: {
    baseURL:
      process.env.REACT_APP_API_BASE_URL ||
      "https://staging-api.innobig.com/api/api",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || "10000", 10),
  },
};

// Get current environment config
const getCurrentConfig = () => {
  return API_CONFIG[ENV] || API_CONFIG.production;
};

export const config = {
  env: ENV,
  api: getCurrentConfig(),
  debug: process.env.REACT_APP_DEBUG === "true",
  appName: process.env.REACT_APP_NAME || "Innobig",
  appVersion: process.env.REACT_APP_VERSION || "1.0.0",

  // API endpoints - can be extended as needed
  endpoints: {
    pages: "/pages",
    programs: "/programs",
    blog: "/blog",
    home: "/home",
    homepage: "/homepage",
    admin: "/admin",
    about: "/about",
    services: "/services",
    media: "/admin/media",
  },

  // Media configuration
  media: {
    uploadDir: "uploads",
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedFormats: ["jpg", "jpeg", "png", "gif", "webp", "pdf"],
  },
};

export default config;
